import { useState } from "react";
import { X } from "lucide-react";

export default function Modal({ open, onClose, title, children, size = "md", testid }) {
  if (!open) return null;
  const widths = { sm: "max-w-md", md: "max-w-xl", lg: "max-w-3xl", xl: "max-w-5xl" };
  return (
    <div
      className="fixed inset-0 z-[80] bg-background/90 backdrop-blur-md p-4 sm:p-8 overflow-y-auto"
      onClick={onClose}
      data-testid={testid || "admin-modal"}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className={`relative ${widths[size]} mx-auto card-elev p-6 md:p-8 mt-6 mb-10`}
      >
        <button
          type="button"
          onClick={onClose}
          className="absolute top-3 right-3 h-9 w-9 rounded-md border border-border hover:border-primary hover:text-primary"
          data-testid="modal-close"
        >
          <X className="h-4 w-4 mx-auto" />
        </button>
        {title && <h2 className="heading-md mb-5 pr-10">{title}</h2>}
        {children}
      </div>
    </div>
  );
}

export function ConfirmDialog({ open, onClose, onConfirm, title = "Emin misin?", body, confirmText = "Sil", testid }) {
  const [busy, setBusy] = useState(false);
  if (!open) return null;
  const run = async () => {
    setBusy(true);
    try { await onConfirm(); onClose(); } finally { setBusy(false); }
  };
  return (
    <Modal open={open} onClose={onClose} title={title} size="sm" testid={testid || "confirm-dialog"}>
      <p className="text-muted-foreground mb-6">{body}</p>
      <div className="flex justify-end gap-3">
        <button type="button" className="btn-secondary" onClick={onClose} data-testid="confirm-cancel">İptal</button>
        <button
          type="button"
          onClick={run}
          disabled={busy}
          className="inline-flex items-center justify-center gap-2 rounded-md bg-destructive px-6 py-3 font-display text-base font-bold uppercase tracking-wider text-destructive-foreground hover:opacity-90 disabled:opacity-60"
          data-testid="confirm-ok"
        >
          {busy ? "Siliniyor..." : confirmText}
        </button>
      </div>
    </Modal>
  );
}
